import React, { useContext, useEffect, useState } from 'react';
import { Form, Input, Table, Calendar, Skeleton, Avatar, Modal, Descriptions, Card, Badge, Button, message } from 'antd';
import { UserOutlined, SecurityScanOutlined, LockOutlined } from '@ant-design/icons';
import { Context } from '../../../defaults';
import { saveChangePassword, getStudentExamsList } from '../../../actions';
import moment from 'moment';
import './index.css';

const { Meta } = Card;


const StudentsInfo = ({ student, user, loading, setAdded }) => {
  const [form] = Form.useForm();
  const { dictionary, language, setLoading } = useContext(Context);
  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);
  const [exams, setExams] = useState([]);
  const [mode, setMode] = useState('month');
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const dateCellRender = (value) => {
    const examDate = exams.filter(m => moment(m.examDate).format('DD.MM.YYYY') === value.format('DD.MM.YYYY'));
    return (
      <ul className="events">
        {
          examDate.map(item => (
            <li key={`examId${item.id}`}>
              <Badge status={'success'} text={`${item.name} (${item.startTime})`} />
            </li>
          ))
        }
      </ul>
    );
  }


  const monthCellRender = (value) => {
    const examDate = exams.filter(m => moment(m.examDate).month() === value.month());
    return (
      <ul className="events">
        {
          examDate.map(item => (
            <li key={`examId${item.id}`}>
              <Badge status={'success'} text={`${item.name} (${item.startTime})`} />
            </li>
          ))
        }
      </ul>
    );
  }

  const onPanelChange = (value, selectedMode) => {
    setMode(selectedMode);
  }

  const showSchedule = (dataSource) => {
    Modal.info({
      title: dictionary?.ExamSchedule[language],
      content: <Table style={{ marginTop: 24 }} dataSource={dataSource.map(el => { return { ...el, key: `exam${el.id}` } })} columns={[
        {
          title: dictionary?.Subject[language],
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: dictionary?.ExamStartDate[language],
          dataIndex: 'examDate',
          key: 'examDate',
          render: (value) => moment(value).format('DD.MM.YYYY')
        },
        {
          title: dictionary?.StartTime[language],
          dataIndex: 'startTime',
          key: 'startTime',
        },
      ]} />,
      onOk() { },
    });
  }

  const selectDate = (value) => {
    if (mode === 'month') {
      const examDate = exams.filter(m => moment(m.examDate).format('DD.MM.YYYY') === value.format('DD.MM.YYYY'));
      showSchedule(examDate);
    }
    else {
      const examDate = exams.filter(m => moment(m.examDate).month() === value.month());
      showSchedule(examDate);
    }
  }

  useEffect(() => {
    getStudentExamsList().then(res => {
      setExams(res.data);
    });
  }, []);

  return (
    <div>
      <Card>
        <Skeleton loading={loading} avatar active>
          <Meta
            avatar={
              <Avatar size={64} icon={<UserOutlined />} />
            }
            title={`${student.lastName} ${student.firstName} ${student.middleName}`}
            description={`${student.country}, ${student.city}, ${student.region}`}
          />
          <Descriptions title={dictionary?.AdditionalInfo[language]} bordered>
            <Descriptions.Item label={dictionary?.Phone[language]} span={2}>{student.phone}</Descriptions.Item>
            <Descriptions.Item label={dictionary?.StudyYear[language]}>{student.studyYear}</Descriptions.Item>
            <Descriptions.Item label={dictionary?.ClassroomTeacher[language]} span={2}>{student.classroomTeacher}</Descriptions.Item>
            <Descriptions.Item label={dictionary?.Class[language]}>{student.class}</Descriptions.Item>
            <Descriptions.Item label={dictionary?.Email[language]} span={2}>{user.email}</Descriptions.Item>
            <Descriptions.Item label={dictionary?.UserName[language]}>{user.login}</Descriptions.Item>
            <Descriptions.Item label={dictionary?.RegDate[language]} span={2}>{moment(user.regDate).format('DD.MM.YYYY')}</Descriptions.Item>
            <Descriptions.Item label={dictionary?.LastChangePassDate[language]}>{user.lastChangePassDate ? moment(user.lastChangePassDate).format('DD.MM.YYYY') : ''}</Descriptions.Item>
            <Descriptions.Item label={dictionary?.LastLoginDate[language]} span={2}>{user.lastLoginDate ? moment(user.lastLoginDate).format('DD.MM.YYYY') : ''}</Descriptions.Item>
            <Descriptions.Item label={dictionary?.Password[language]}>
              <Button type="dashed" icon={<SecurityScanOutlined />} onClick={() => { setOpenChangePasswordModal(true) }}>
                {dictionary?.ChangePassword[language]}
              </Button>
            </Descriptions.Item>
          </Descriptions>
        </Skeleton>
      </Card>
      <div className='site-card-border-less-wrapper'>
        <Card title={dictionary?.ExamSchedule[language]} bordered={false}>
          <Calendar dateCellRender={dateCellRender} monthCellRender={monthCellRender} onPanelChange={onPanelChange} onSelect={selectDate} />
        </Card>
      </div>

      <Modal onOk={() => {
        const { password, rePassword } = form.getFieldsValue();
        if (password === rePassword) {
          setLoading(true);
          saveChangePassword({ password }).then(res => {
            setLoading(false);
            setOpenChangePasswordModal(false);
            form.resetFields();
            setAdded(true);
            message.success(dictionary?.SuccessfullyChanged[language], { duration: 2 });
          }).catch(() => {
            setLoading(false);
            form.resetFields();
            message.error(dictionary?.SomethingWentWrong[language], { duration: 4 })
          });
        }
        else {
          form.validateFields();
          message.error(dictionary?.PasswordsAreNotSame[language]);
        }
      }}
        okButtonProps={{ disabled: buttonDisabled }}
        onCancel={() => { setOpenChangePasswordModal(false) }}
        title={dictionary?.ChangePassword[language]} visible={openChangePasswordModal} >
        <Form
          form={form}
          style={{ marginTop: 24 }}
          onFieldsChange={
            () => {
              const { password, rePassword } = form.getFieldsValue();
              setButtonDisabled(!password || !rePassword);
            }
          }
        >
          <Form.Item name='password' rules={[{ required: true, message: dictionary?.FillTheField[language] }]}>
            <Input prefix={<LockOutlined />} type='password' placeholder={dictionary?.Password[language]} />
          </Form.Item>
          <Form.Item name='rePassword' rules={[{ required: true, message: dictionary?.FillTheField[language] }]}>
            <Input prefix={<LockOutlined />} type='password' placeholder={dictionary?.RePassword[language]} />
          </Form.Item>
        </Form >
      </Modal>
    </div >
  );
}

export default StudentsInfo;